import React from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useFetchAll } from "../../custom/FetchApiHook";
import { multilevelApprovalApi } from "../../App/api/multilevelApproval.api";
// import useFetchAll from "@/hooks/useFetchAll"; // Custom hook for fetching approvals
// import multilevelApprovalApi from "@/api/multilevelApprovalApi"; // API function

const ApprovalFlowManager = ({ component, currentItems, approvalStatus }) => {
  const currentUser = useSelector((state) => state.store.currentUser);
  const user = currentUser?.data?.user;

  const { value: allApprovals, fetchAllData } = useFetchAll(() =>
    multilevelApprovalApi.getAllApprovals({ filter: { component } })
  );

  // Find the approval level of the current user
  const approvalLevel = allApprovals?.data?.[0]?.approvalFlow?.find(
    (d) => d?.user?._id === user?._id
  );

  // Filter approvals related to the current user
  const approvedData = approvalStatus?.filter(
    (item) => item?.progress?.user?._id === approvalLevel?.user?._id
  );

  // Filter approvals matching the current component
  const ApprovalFlow = approvedData?.filter(
    (l) => l.component_id === currentItems?._id
  );


  // Find all first-level approvals
  const firstLevels = allApprovals?.data?.flatMap((item) =>
    item?.approvalFlow?.map((flow) => ({
      level: flow.level,
      user: flow.user?.first_name,
    }))
  );

  // Filter approval statuses based on the component ID
  const filterApprovalStatus = approvalStatus?.filter(
    (item) => item?.component_id === currentItems?._id
  );

  // Find matched approvals
  const matchedData = filterApprovalStatus?.filter((item) =>
    firstLevels?.some((level) => level.level === item.progress.level)
  );

  // Find waiting approvals
  const waitingForApproval = firstLevels?.filter(
    (level) =>
      !filterApprovalStatus?.some((item) => item.progress.level === level.level)
  );

  // Validation function
  const validateAndApprove = (data, message) => {
    if (
      !data.progress.level ||
      !data.progress.user ||
      data.progress.user === "undefined"
    ) {
      console.log("approval data:",data)
      toast.error(message || "You don't have permission to approve.");
      return false;
    }
    console.log("Approval granted");
    return true;
  };

  return {
    approvalLevel,
    allApprovals,
    ApprovalFlow,
    firstLevels,
    matchedData,
    waitingForApproval,
    fetchAllData,
    validateAndApprove,
  };
};

export default ApprovalFlowManager;
